module.exports = __webpack_public_path__ + "static/media/builds-icon.0c85e41d.svg";